import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';


@Component({
  selector: 'app-year-picker',
  templateUrl: './year-picker.component.html',
  styles: [],
})
export class YearPickerComponent implements OnInit {

  constructor() { }

  @Input() startYear: number = new Date().getFullYear() - 5;
  @Input() endYear: number = new Date().getFullYear() + 5;
  @Input() selectedYear!: number;
  @Output() selectedYearChange = new EventEmitter<number>();

  years: { label: string, value: number }[] = [];

  ngOnInit() {
    this.years = [];
    for (let y = this.startYear; y <= this.endYear; y++) {
      this.years.push({ label: y.toString(), value: y });
    }
  }

  onYearChange() {
    this.selectedYearChange.emit(this.selectedYear);
  }


}
